export const CustomFieldActionContribution = Symbol('CustomFieldActionContribution');
